"use client"
import { NestedNavigationLinksType } from "common/SiteLinks"
import { setOpen } from "components/shopFeatures/auth/authSlice"
import { Dispatch, SetStateAction } from "react"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"
import colors from "theme/colors"
import { TypographyCenter } from "theme/shared"

export const StyledTypographyCenter = styled(TypographyCenter)`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

type Props = {
  item: NestedNavigationLinksType
  selectedLink: any
  setDialogOpen: Dispatch<SetStateAction<boolean>>
}

const ShopAuthLink = ({ item, selectedLink, setDialogOpen }: Props) => {
  const { auth } = useTypedSelector((state) => state)
  const { authenticated, userInfo } = auth
  const dispatch = useAppDispatch()

  return (
    <>
      <StyledTypographyCenter
        variant="body1"
        role="button"
        tabIndex={0}
        $color={item.title === selectedLink ? colors.white : colors.borderGrey}
        $fontWeight={item.title === selectedLink ? "bold" : "normal"}
        onClick={() => {
          authenticated ? setDialogOpen(true) : dispatch(setOpen(true))
        }}
      >
        {authenticated ? `היי, ${userInfo?.firstName}` : item.title}
      </StyledTypographyCenter>
    </>
  )
}

export default ShopAuthLink
